import { useTranslations } from 'next-intl';
import cx from 'classnames';
import Styles from './mIndex.module.scss';

export enum ThreadTagType {
  top = 'top',
  selected = 'selected',
  latest = 'latest',
  audit = 'audit',
  rejected = 'rejected',
}

export interface IThreadTag {
  className?: string;
  type: ThreadTagType;
}

const ThreadTag = ({
  className = '',
  type,
}: IThreadTag) => {
  const t = useTranslations();

  return (
    <span className={cx(Styles.root, className, {
      [Styles[type]]: !!type,
    })}>
      {t(`btn_tag_${type}`)}
    </span>
  );
};

export default ThreadTag;
